import { Link } from 'react-router-dom';

import classNames from 'classnames';

interface SidebarLinkProps {
  link: {
    name: string;
    path: string;
    icon?: string;
    disabled: boolean;
  };
  active: boolean;
}

const SidebarLink = ({ link, active }: SidebarLinkProps) => {
  return (
    <Link
      to={link.path}
      className={classNames(
        'sidebar-link flex items-center font-semibold p-2 px-4 mb-2 rounded hover:bg-primary-10 text-black h:text-black transition duration-200',
        { 'cursor-not-allowed pointer-events-none opacity-50': link.disabled },
        { 'bg-primary-10': active },
      )}
    >
      {link.icon && (
        <span className="mr-4">
          <img src={link.icon} alt={`${link.name} icon`} />
        </span>
      )}
      <span>{link.name}</span>
    </Link>
  );
};

export default SidebarLink;
